/**
 * Hooks de notificaciones · TanStack Query. La suscripción realtime la monta
 * NotificationBell (que ya tiene el userId de sesión y el ciclo de vida).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import * as api from './api';

export const NOTIFICATIONS_KEY = ['core', 'notifications', 'unread'] as const;

export function useMyNotifications() {
  return useQuery({
    queryKey: NOTIFICATIONS_KEY,
    queryFn: api.listMyUnreadNotifications,
    staleTime: 60_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.markNotificationRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.markAllNotificationsRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY }),
    onError: (e: Error) =>
      toast.error('No se pudo marcar como leído', { description: e.message }),
  });
}
